import React, { Component } from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";

interface IGameControlComponent {
    data: {}
}
export const gameControlComponent: IGameControlComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameControlScrollComponent",
                        "name": "gameControlScrollComponent",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                        ]
                    },
                    {
                        "id": "gameControlContent",
                        "name": "gameControlContent",
                        "type": "Container",
                        "x": -100,
                        "y": -100,
                        "visible": true,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "Control_Spin_Container",
                                "name": "Control_Spin_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Spin_Heading",
                                        "name": "Spin_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_spin",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Spin__text",
                                        "name": "Control_Spin__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_spin",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "spin_icon",
                                        "image": "spin_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 47,
                                        "height": 45,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },

                            {
                                "id": "Control_Bet_Container",
                                "name": "Control_Bet_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 100,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Bet_Heading",
                                        "name": "Bet_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_stake",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Bet__text",
                                        "name": "Control_Bet__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_stake",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Bet_icon",
                                        "image": "bet_control_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 33,
                                        "height": 27,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Menu_Container",
                                "name": "Control_Menu_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 200,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Menu_Heading",
                                        "name": "Menu_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_menu",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Menu__text",
                                        "name": "Control_Menu__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_menu",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Menu_icon",
                                        "image": "menu_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 94,
                                        "height": 39,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Sound_Container",
                                "name": "Control_Sound_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 300,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Sound_Heading",
                                        "name": "Sound_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_sound",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Sound__text",
                                        "name": "Control_Sound__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_sound",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Sound_icon",
                                        "image": "sound_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 101,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Paytable_Container",
                                "name": "Control_Paytable_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 400,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Paytable_Heading",
                                        "name": "Paytable_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_paytable",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Paytable__text",
                                        "name": "Control_Paytable__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_paytable",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Paytable_icon",
                                        "image": "paytable.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 37,
                                        "height": 30,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_BetHistory_Container",
                                "name": "Control_BetHistory_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 500,
                                "visible": true,
                                child: [
                                    {
                                        "id": "BetHistory_Heading",
                                        "name": "BetHistory_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_bet-history",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_BetHistory__text",
                                        "name": "Control_BetHistory__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_bet-history",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "BetHistory_icon",
                                        "image": "bet_history_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 42,
                                        "height": 37,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Settings_Container",
                                "name": "Control_Settings_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 600,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Settings_Heading",
                                        "name": "Settings_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_settings",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Settings__text",
                                        "name": "Control_Settings__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "Settings_control_txt",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Settings_icon",
                                        "image": "setting_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 36,
                                        "height": 36,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_GameGuide_Container",
                                "name": "Control_GameGuide_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 700,
                                "visible": true,
                                child: [
                                    {
                                        "id": "GameGuide_Heading",
                                        "name": "GameGuide_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_game-guide",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_GameGuide__text",
                                        "name": "Control_GameGuide__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_game-guide",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "GameGuide_icon",
                                        "image": "game_guide_icon.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 29,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Autoplay_Container",
                                "name": "Control_Autoplay_Container",
                                "type": "Container",
                                "x": 0,
                                "y": 800,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Autoplay_Heading",
                                        "name": "Autoplay_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_autoplay",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Autoplay__text",
                                        "name": "Control_Autoplay__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_autoplay",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },
                                    {
                                        "name": "Autoplay_icon",
                                        "image": "autoplay.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 161,
                                        "height": 45,
                                        "anchor": [0.5, 0.5],
                                        "x": 1125,
                                        "y": 190,

                                    },


                                ]
                            },
                            {
                                "id": "Control_Buy_Feature",
                                "name": "Control_Buy_Feature",
                                "type": "Container",
                                "x": 0,
                                "y": 900,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Buy_Feature_Heading",
                                        "name": "Buy_Feature_Heading",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 150,
                                        "width": 300,
                                        "visible": true,
                                        "text": "game-guide_control_heading_buy-a-feature",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Control_Buy_Feature__text",
                                        "name": "Control_Buy_Feature__text",
                                        "type": "Text",
                                        "x": 310,
                                        "y": 180,
                                        "width": 700,
                                        "visible": true,
                                        "text": "game-guide_control_body_buy-a-feature",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 22,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                        },
                                    },


                                    {
                                        "id": "buy_now_icon",
                                        "name": "buy_now_icon",
                                        "type": objectTypes.Sprite,
                                        "buttonMode": false,
                                        "uimode": "desktop",
                                        "interactive": false,
                                        "layout": false,
                                        "x": 1129,
                                        "y": 181,
                                        "width": 110.5,
                                        "height": 51,
                                        "text": "buy-a-feature-button-text",
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 46,
                                            fontStyle: 'bold',
                                            fill: ['#f0e700', '#fd9d08'],
                                            wordWrap: true,
                                            wordWrapWidth: 200,
                                            stroke: '#ca0606',
                                            strokeThickness: 4,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "visible": true,
                                        "buttonState": {
                                            up: 'bonus_buy_up.png',
                                            out: 'bonus_buy_up.png',
                                            down: 'bonus_buy_down.png',
                                            disable: 'bonus_buy_disable.png',
                                            enable: 'bonus_buy_up.png',
                                            hover: 'bonus_buy_over.png'
                                        },
                                        "hitareaVisible": false,
                                        "shapeVisible": false,
                                        "shape": {}
                                    },
                                ]
                            },
                           
                        ]
                    },
                ]
            },

        ],
    }


};

export const GameControlComponentConfigurationContext = React.createContext(
    {}
);